<template>
  <div class="flex h-10 px-2 border justify-between items-center rounded-full">
    <button
      @click="changeQuantity(-1)"
      :class="{'opacity-25': quantity <= moq}"
    >
      <i class="material-icons align-middle">remove</i>
    </button>
    <ValidationProvider v-slot="{ errors }" :rules="`minRange:${moq}|required`">
      <input
        type="number"
        class="w-16 text-center pt-2px"
        v-model="productQuantity"
        name="Quantity"
        @blur="onQuantityBlur"
      >
      <div class="input-error absolute left-0 pt-3">{{ errors[0] }}</div>
    </ValidationProvider>
    <button
      @click="changeQuantity(1)"
      class="focus:outline-none"
    >
      <i class="material-icons align-middle">add</i>
    </button>
  </div>
</template>
<script>
export default {
  name: 'QuantityChanger',
  props: {
    product: {
      required: true
    },
    quantity: {
      required: true
    }
  },
  computed: {
    moq() {
      return this.product.minimumOrderQuantity
    },
    productQuantity: {
      get() {
        return this.quantity
      },
      set(val) {
        this.$emit('setQuantity', val)
      }
    }
  },
  methods: {
    changeQuantity(val) {
      val = parseInt(val)
      let quantity = this.quantity
      const newQuantity = (val === -1 && quantity === this.moq)
        ? quantity
        : quantity + (val * this.product.quantityIncrement)
      quantity = newQuantity >= this.moq ? newQuantity : quantity
      this.$emit('changeQuantity', quantity)
    },
    onQuantityBlur() {
      let quantity = parseInt(this.quantity) || this.moq
      if (quantity < this.moq)
        quantity = this.moq
      this.$emit('changeQuantity', quantity)
    }
  }
}
</script>
